import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Shipped stats',
  description: 'Displays shipped orders and boxes for selected period'
};



// WEBPACK FOOTER //
// ./app/widgets.new/ShippedStats/index.js